/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$('.testimonial-slider-wrapper').slick({
  slidesToShow: 2,
  slidesToScroll: 2,
  infinite: true,
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" role="presentation" style="width:var(--rsw, 100%);height:100%" class="r-1y7dt1y"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" role="presentation" style="width:var(--rsw, 100%);height:100%" class="r-1y7dt1y"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path></svg></button>',
  autoplaySpeed: 2000,
  dots: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 768, // Adjust this as per your requirement
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

 $('.product-side-sub-images').slick({
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: false,
          asNavFor: '.product-main-images',
          prevArrow: '<button type="button" class="media-gallery__arrow media-gallery__arrow--prev"><i class="icon icon--left"></i></button>',
          nextArrow: '<button type="button" class="media-gallery__arrow media-gallery__arrow--next"><i class="icon icon--right"></i></button>',
          responsive: [
            {
              breakpoint: 1081,
              settings: {
                fade: true,
                speed: 300,
                cssEase: 'ease-out'
              }
            }
          ]
    });
    
    $('.product-main-images').slick({
        focusOnSelect: true,
          accessibility: true,
          ariaPolite: false,
          slidesToShow: 1,
          asNavFor: '.product-side-sub-images',
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          swipe: true,
          adaptiveHeight: true,
          mobileFirst: true,
          fade: false,
          speed: 0,
          arrows: true,
          prevArrow: '<button type="button" class="media-gallery__arrow media-gallery__arrow--prev"><i class="icon icon--left"></i></button>',
          nextArrow: '<button type="button" class="media-gallery__arrow media-gallery__arrow--next"><i class="icon icon--right"></i></button>',
          responsive: [
            {
              breakpoint: 1081,
              settings: {
                fade: true,
                speed: 300,
                cssEase: 'ease-out'
              }
            }
          ]
    });

$('.product-side-sub-images img').click(function () {
    $('.product-side-sub-images img').css("border", "0px solid black")
    $(this).css("border", "1px solid black");
	var current_sub_image = $(this).attr('data-media-id')
	for (let i = 0; i < $('.product-main-images .media-gallery__item').length; ++i) {
     var current_main_image_id = $($('.product-main-images .media-gallery__item')[i]).attr('data-media-id')
       if(current_sub_image == current_main_image_id){
	    var current_slide_index = $($('.product-main-images .media-gallery__item')[i]).parent().parent().parent().attr('data-slick-index')
        $('.product-main-images').slick('slickGoTo', current_slide_index);
	   }
    }
});

$('.js-section__home-product-2 .product-form__swatch__title-colors .product-form__swatch__item').click(function () {
    var main_variant_id = $(this).attr('data-variant-id')
    for (let i = 0; i < $('.product-main-images .media-gallery__item').length; ++i) {
    if($($('.product-main-images .media-gallery__item')[i]).attr('data-variant-id')){
     var main_image_id = $($('.product-main-images .media-gallery__item')[i]).attr('data-variant-id').split(',')[1].trim()
    }
	 
       if(main_variant_id == main_image_id){
	    var variant_slick_index = $($('.product-main-images .media-gallery__item')[i]).parent().parent().parent().attr('data-slick-index')
        $('.product-main-images').slick('slickGoTo', variant_slick_index);
	   }
    }
})


$(".accordion .accordion-thumb").click(function() {
  $(this).toggleClass("is-active-thumb").closest(".accordion-item").toggleClass("is-active").find(".accordion-panel").slideToggle();
  $(this).find(".icon-i").toggleClass("rotate--icons");
});


  $('.accordion-header').click(function () {
      $(this).toggleClass('active');
      $(this).next().slideToggle();
  });

  var observer = new MutationObserver(function(mutationsList, observer) {
    for (var mutation of mutationsList) {
        if (mutation.type === 'childList') {
            var targetElement = document.querySelector('.cart__wrapper .qbk-relative-teleport');
            if (targetElement) {
              if(targetElement.querySelector('.qbk-order-goal__milestone').classList.contains('qbk-order-goal__milestone--gift-done') || targetElement.querySelector('.qbk-order-goal__milestone').classList.contains('qbk-order-goal__milestone--gift-pending')){
                let free_gift = `<div class="cart__free-gift">`;
                free_gift += `<svg id="qbk-icon-gift" viewBox="0 0 24 24"><path d="M19.5 6.25h-1.065A2.709 2.709 0 0 0 18.75 5a2.747 2.747 0 0 0-4.876-1.739L12 5.752l-1.881-2.5A2.747 2.747 0 0 0 5.25 5a2.709 2.709 0 0 0 .315 1.25H4.5A2.253 2.253 0 0 0 2.25 8.5V12a.75.75 0 0 0 .75.75h.25V18A3.383 3.383 0 0 0 7 21.75h10A3.383 3.383 0 0 0 20.75 18v-5.25H21a.75.75 0 0 0 .75-.75V8.5a2.253 2.253 0 0 0-2.25-2.25zm.75 2.25v2.75h-7.5v-3.5h6.75a.751.751 0 0 1 .75.75zm-5.211-4.293A1.223 1.223 0 0 1 16 3.75a1.25 1.25 0 0 1 0 2.5h-2.5l1.539-2.043zM6.75 5A1.252 1.252 0 0 1 8 3.75a1.213 1.213 0 0 1 .948.441L10.5 6.25H8A1.252 1.252 0 0 1 6.75 5zm-3 3.5a.751.751 0 0 1 .75-.75h6.75v3.5h-7.5zm1 9.5v-5.25h6.5v7.5H7c-1.577 0-2.25-.673-2.25-2.25zm14.5 0c0 1.577-.673 2.25-2.25 2.25h-4.25v-7.5h6.5z"></path></svg>`;
                if($('.qbk-order-goal__milestone--gift-done').length > 0){
                  free_gift += `<span>Change your free gift</span>`;
                }else{
                  free_gift += `<span>Select your free gift</span>`;
                }
                free_gift += `</div>`;
                $('.cart--draw .cart__details').prepend(free_gift);
                observer.disconnect(); // Stop observing if the element is found
                break;
              }
            }
        }
    }
});

observer.observe(document.body, { childList: true, subtree: true });

$(document).on('click','.cart__free-gift',function () {
  $('.qbk-order-goal__milestone').trigger('click');
});